import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=59b33281&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=js"
export * from "./AgentList.vue?vue&type=script&lang=js"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=59b33281&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b33281",
  null
  
)

export default component.exports